export default __webpack_public_path__ + "static/media/sl.ec1ec422.svg";